import BaseChip from './Chip';

// EXPORT
export const Chip = BaseChip;
export type { ChipProps } from './Chip.interface';
